import { inject } from '@angular/core'
import { CanActivateChildFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'
import { homeFor, lacksProductFor } from '../../shared/utils/products'

/**
 * Platform / Library (CC, 08/10/2026): a page of a product the account does not have sends them
 * to the one they do -- a Library-only coach opening "/" lands in the Library, a Platform-only
 * one opening /library lands on Home. The server refuses the same addresses; this keeps people
 * from ever reaching a page that would only show errors.
 *
 * The saved account can be out of date -- a session refresh once came back with every product
 * off and sent admins to /live (CC, 12/10/2026) -- so before sending anyone away the guard asks
 * the server once. Someone who does have the page never pays for that request.
 */
export const productGuard: CanActivateChildFn = async (_route, state) => {
  const auth = inject(AuthService)
  const router = inject(Router)
  const cached = auth.currentUser()
  if (!cached) return true // completeAuthGuard deals with signing in
  if (!lacksProductFor(cached, state.url)) return true
  const user = (await auth.refreshCurrentUser(false)) ?? cached
  return lacksProductFor(user, state.url) ? router.createUrlTree([homeFor(user)]) : true
}
